// extracted by mini-css-extract-plugin
export default {"root":"FeatureSection_root__39jBc","title":"FeatureSection_title__3HC4p","cardContainers":"FeatureSection_cardContainers__hxmkx","gap":"FeatureSection_gap__ywMaH"};